export default __webpack_public_path__ + "static/media/bigboy.c2a3d70c.jpg";